import KneeIcon from "../assets/images/orthocheck/Knee.png";
import ShoulderIcon from "../assets/images/orthocheck/shoulder.png";
import HandIcon from "../assets/images/orthocheck/hand.png";
import FootIcon from "../assets/images/orthocheck/foot.png";
import BackIcon from "../assets/images/orthocheck/back.png";
import NeckIcon from "../assets/images/orthocheck/neck.png";
import HipIcon from "../assets/images/orthocheck/hip.png";
import ElbowIcon from "../assets/images/orthocheck/elbow.png";
import TeethIcon from "../assets/images/orthocheck/teeth.svg";
import JawIcon from "../assets/images/orthocheck/jaw.svg";
import GumsIcon from "../assets/images/orthocheck/gums.svg";
import TonguePalateIcon from "../assets/images/orthocheck/tongue_palate_and_cheek.svg";

export const RemoveOrthoCheckLocalStorageAndSessionStorage = async () => {
  localStorage.removeItem("orthocheck_results");
  localStorage.removeItem("orthocheck_initiate");
  localStorage.removeItem("orthocheck_ai_initiate");
  localStorage.removeItem("isDemographics");
  localStorage.removeItem("assessment_start_time");
  localStorage.removeItem("demographics");
  localStorage.removeItem("specialist_card");
  sessionStorage.removeItem("locationCoordinates");
  sessionStorage.removeItem("locationAddress");
};

export const RemoveOrthoCheckProviderInfo = async () => {
  localStorage.removeItem("provider_info");
  localStorage.removeItem("provider_enhanced");
  localStorage.removeItem("provider_api_key");
  localStorage.removeItem("schedulers_customer_config");
  sessionStorage.removeItem("provider");
};

export const getName = (provider) => {
  const toTitleCase = (str) =>
    str.replace(
      /\w\S*/g,
      (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  // Case 1: Enhanced or bulk uploaded → return provider.name directly
  if (provider?.isEnhancedProvider || provider?.isBulkUploaded) {
    return provider?.name ? String(provider.name).trim() : "";
  }

  // Case 2: Build name from prefix/first/last/suffix
  const prefix = provider?.prefix
    ? `${toTitleCase(String(provider.prefix).replace(/[^A-Za-z]/g, ""))}. `
    : "";

  const firstName = provider?.firstName
    ? toTitleCase(String(provider.firstName))
    : "";
  const lastName = provider?.lastName
    ? toTitleCase(String(provider.lastName))
    : "";

  const suffix = provider?.suffix
    ? `, ${String(provider.suffix).toUpperCase()}`
    : "";

  return `${prefix}${[firstName, lastName].filter(Boolean).join(" ")}${suffix}`;
};

export const getProviderName = (provider) => {
  return <span>{getName(provider)}</span>;
};

export const OrthopedicsMuscleTypes = [
  { name: "Knee", image: KneeIcon, slug: "knee", bodyPart: "knee" },
  {
    name: "Shoulder",
    image: ShoulderIcon,
    slug: "shoulder",
    bodyPart: "shoulder",
  },
  {
    name: "Hand & Wrist",
    image: HandIcon,
    slug: "hand_wrist",
    bodyPart: "hand_and_wrist",
  },
  {
    name: "Foot & Ankle",
    image: FootIcon,
    slug: "foot_ankle",
    bodyPart: "foot_and_ankle",
  },
  { name: "Back", image: BackIcon, slug: "back", bodyPart: "back" },
  { name: "Neck", image: NeckIcon, slug: "neck", bodyPart: "neck" },
  { name: "Hip", image: HipIcon, slug: "hip", bodyPart: "hip" },
  { name: "Elbow", image: ElbowIcon, slug: "elbow", bodyPart: "elbow" },
];

export const DentistryMuscleTypes = [
  { name: "Teeth", image: TeethIcon, slug: "teeth", bodyPart: "teeth" },
  { name: "Jaw", image: JawIcon, slug: "jaw", bodyPart: "jaw" },
  { name: "Gums", image: GumsIcon, slug: "gums", bodyPart: "gums" },
  {
    name: "Soft Tissue",
    image: TonguePalateIcon,
    slug: "tongue_palate_and_cheek",
    bodyPart: "tongue_palate_and_cheek",
  },
];

export const MuscleTypes = [...OrthopedicsMuscleTypes, ...DentistryMuscleTypes];

export const getFilteredBodyParts = (specialties, isPractice) => {
  if (
    !specialties?.length ||
    specialties.includes("orthopedics") ||
    !isPractice
  ) {
    return MuscleTypes;
  }

  return specialties
    .map((specialty) =>
      MuscleTypes.find((item) =>
        [item.url_data, item.unique_id].includes(specialty)
      )
    )
    .filter(
      (item, index, self) =>
        item &&
        index ===
          self.findIndex((obj) =>
            [obj?.url_data, obj?.unique_id].includes(
              item?.url_data || item?.unique_id
            )
          )
    );
};
